import React, { useEffect, useState } from "react";
import { Stack, Button, Fade, Box, IconButton, Modal } from "@mui/material";
import DoneImage from "../../Components/assets/Images/congratsdoneimage.svg";
import styles from "../../pages/Styles/Congratulation.module.scss";
import PDFViewerIframe from "../../Components/PDFIframe/PDFWithIframe";
import CloseIcon from "@mui/icons-material/Close";
import esignImage from "../../Components/assets/Images/Account Closure Request Form_page-0001.jpg";
import { stageDetailsAPICall } from "./APICallsAccountClosure";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  padding: "0px 0px 0px 5px",
};

export default function AccountClosureApproved() {
  const [showModal, setshowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [open, setOpen] = React.useState(true);
  const requestID: any = sessionStorage.getItem("acrequestID");

  useEffect(() => {
    window.scrollTo(0, 0);
    // checkUserLoggedIn(navigate);
    StageDetails();
  }, []);

  const StageDetails = () => {
    let obj: any = {
      stage: "congratulations",
      request_id: requestID,
    };
    stageDetailsAPICall(obj)
      .then((response: any) => {
        if (response.data.data.url) {
          setPdfUrl(response.data.data.url);
        }
        // if (response.data.data.StageDetails.Documents.e_sign_pdf) {
        //   setClientCode(
        //     response.data.data.StageDetails.Documents.e_sign_pdf.ClientCode
        //   );
        // }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  const handlePreviewClick = () => {
    setshowModal(true);
  };

  const handlePreviewClose = () => {
    setshowModal(false);
  };

  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>
              Your Account Closure Request Has Been Submitted
            </p>

            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                We’ve received your application and are processing your account
                closure. You will be notified once the process is complete.
              </p>
            </div>
            <Button
              type="submit"
              variant="contained"
              sx={{
                width: "200px",
                height: "50px",
              }}
              className={styles.previewButton}
              id="aadharOpenLinkButton"
              onClick={handlePreviewClick}
            >
              View Esign Document
            </Button>
          </div>
        </div>
      </div>

      {showModal && (
        <Stack>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                {/* <PdfModal
                // url={"https://arxiv.org/pdf/quant-ph/0410100.pdf"}
                url={documentURL}
              /> */}
                <Stack
                  alignItems={"flex-end"}
                  marginRight={"10px"}
                  marginTop={"5px"}
                >
                  <IconButton onClick={handlePreviewClose}>
                    <CloseIcon />
                  </IconButton>
                </Stack>
                <div className={styles.pdfMobilePreview}>
                  <img
                    src={esignImage}
                    style={{
                      width: "95%",
                      height: "100%",
                      objectFit: "inherit",
                      filter: "brightness(80%)",
                      marginBottom: "20px",
                    }}
                  />

                  <a
                    href={pdfUrl}
                    download="Esign-PDF-document"
                    target="_blank"
                    rel="noreferrer"
                    className={styles.previewdownlaodesign}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        background: "#1976d2",
                        "&:hover": { background: "#1976d2" },
                      }}
                    >
                      View Esign Document
                    </Button>
                  </a>
                </div>
                <div className={styles.pdfDesktopPreview}>
                  <PDFViewerIframe urldata={pdfUrl} />
                </div>
              </Box>
            </Fade>
          </Modal>
        </Stack>
      )}
    </div>
  );
}
